import { Route, Routes } from "react-router-dom"
import PermissionList from "./components/PermissionList"

export default function AdminPermissionsPage() {
  return (
    <Routes>
      <Route index element={<PermissionList />} />
    </Routes>
  )
}
